export default "__VITE_ASSET__8oMpKQT1__"